var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { BaseComponent } from '../../../../common/components/base.component';
import { ModalService } from '../../../../common/services/modal.service';
import { HubEvent } from '../../../../models/hub/hub.event';
import { ImageService } from '../../../../services/image.service';
import { EditorChoiceStore } from '../../../../stores/hub.calendar.store';
import { EventDetailsModalComponent } from '../../event.details.modal/event.details.modal.component';
import { EventDetailsModalActions } from '../../event.details.modal/event.details.modal.provider';
import { TripDetailModalComponent } from '../../trip/trip.detail.modal/trip.detail.modal.component';
import { TripDetailModalActions, TripDetailModalData } from '../../trip/trip.detail.modal/trip.detail.modal.provider';
var VisitorEventCardComponent = /** @class */ (function (_super) {
    __extends(VisitorEventCardComponent, _super);
    function VisitorEventCardComponent(router, modalService, editorChoiceStore, imageService, activatedRoute) {
        var _this = _super.call(this, { activatedRoute: activatedRoute }) || this;
        _this.router = router;
        _this.modalService = modalService;
        _this.editorChoiceStore = editorChoiceStore;
        _this.imageService = imageService;
        _this.activatedRoute = activatedRoute;
        _this.editorChoiceText = '';
        return _this;
    }
    VisitorEventCardComponent.prototype.ngOnInit = function () {
        var hubName = this.allRouteParams.hubName;
        this.hubName = hubName;
        this.editorChoiceTextHandler();
    };
    VisitorEventCardComponent.prototype.editorChoiceTextHandler = function () {
        var _this = this;
        this.editorChoiceStore.infoCommand
            .takeUntil(this.isDestroyed)
            .subscribe(function (editorChoice) {
            if (!!_this.event.startTime) {
                _this.editorChoiceText = editorChoice.editorChoiceForEvent;
            }
            else {
                _this.editorChoiceText = editorChoice.editorChoiceForPlace;
            }
        });
    };
    VisitorEventCardComponent.prototype.enterItemByKeyboard = function ($event) {
        if ($event && $event.key === 'Enter') {
            this.showDetails();
        }
    };
    VisitorEventCardComponent.prototype.showDetails = function () {
        if (this.event.isPromotionImage) {
            window.open(this.event.promotionLink, '_blank');
            return;
        }
        if (!this.isMobile) {
            this.event.hubName = this.hubName;
            var actions = {
                confirm: function (event, data) {
                },
            };
            this.modalService.show({
                component: EventDetailsModalComponent,
                providers: [
                    { provide: EventDetailsModalActions, useValue: actions },
                    { provide: HubEvent, useValue: this.event },
                ],
                panelClass: 'modal-fixed-top-lower',
            });
        }
        else {
            this.showDetailModalForMobile(this.event, 'event');
        }
    };
    VisitorEventCardComponent.prototype.showDetailModalForMobile = function (item, displayingOn, isShowAddToTripBtn, index) {
        if (isShowAddToTripBtn === void 0) { isShowAddToTripBtn = false; }
        var actions = {
            confirm: function (event) {
            },
        };
        this.modalService.show({
            component: TripDetailModalComponent,
            providers: [
                { provide: TripDetailModalActions, useValue: actions },
                {
                    provide: TripDetailModalData,
                    useValue: new TripDetailModalData(item, displayingOn, this.hubName, null, null, isShowAddToTripBtn, index),
                },
            ],
            panelClass: ['width-modal-100p', 'ig-trip-info-modal'],
        });
    };
    return VisitorEventCardComponent;
}(BaseComponent));
export { VisitorEventCardComponent };



// WEBPACK FOOTER //
// D:/Work/Development/ImGoing/IMGoing/web/src/components/visitor/calendar/event.card/visitor.event.card.component.ts.pre-build-optimizer.js